import React from "react";
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";
import Paragraph from "@components/Paragraph";
import {services} from "./config";

interface SignupSectionProps {
  serviceId: string;
  videoId: string;
}

const Video: React.FC<SignupSectionProps> = ({serviceId= 'youtube', videoId = '2Xc9gXyf2G4'}) => {
  const service = services.find(service => service.id === serviceId)
  if (!service) {
    throw 'Video service invalid. Try with one of the following: youtube'
  }
  const {url} = service
  return (
    <Paragraph>
      <VideoIframe
        src={url(videoId)}
        allowFullScreen
        scrolling="no"
        sandbox="allow-same-origin allow-scripts allow-popups"
      />
    </Paragraph>
  );
};

const VideoIframe = styled.iframe`
  width: 100%;
  height: 440px;
  border: 0;
  ${mediaqueries.phablet`
    height: 250px;
  `};
`;

export default Video;
